export default {
  zh: {
    plexRemoved: 'Plex加速器已从App Store 中国区下架',
    plexRemovedInfo: 'Plex加速器已在IOS中国区下架，如果您使用的是中国区的Apple ID，客户端暂时无法直接订阅。但这不影响我们的客户端提供服务，您依然可以登录我们的官网地址管理您的账户信息、充值或寻求帮助。',
    visitMethods: '您可以通过以下几种方式访问我们的官网：',
    firstMethod: '1. 通过搜索引擎搜索“Plex加速器”',
    secondMethod: '2. 直接访问官网地址：',
    suggest: '建议您把我们的官网地址收藏起来，便于下次访问。'
  },
  en: {
    plexRemoved: 'PlexVPN has been removed from App Store in China',
    plexRemovedInfo: 'PlexVPN has been removed from APP Store in China, we are unable to provide subscription service for Chinese Apple ID. But our Apple client will continue to provide VPN service for you. You can login our official site to manage your account, recharge or ask for a help.',
    visitMethods: 'You can visit our official site by the following methods:',
    firstMethod: '1. Searching “PlexVPN” by search engines;',
    secondMethod: '2. Visit our official site directly: ',
    suggest: 'It is recommended that you can bookmark our site URL. It is convenient for you to visit next time. '
  }
}



// WEBPACK FOOTER //
// ./src/views/landingPage/iosReach/lang.js